<template>
  <div class="e6-image">
    <div v-if="!isExist" class="e6-image__item" :class="'e6-image__error'">
      <slot name="error">
        <i
          :class="[
            failType === 'error'
              ? 'el-icon-picture-outline'
              : 'e6-icon-prohibit_line'
          ]"
        ></i>
        <div class="text">
          {{ failType === "error" ? "图片加载失败" : "暂无图片" }}
        </div>
      </slot>
    </div>
    <template v-else>
      <img
        class="el-image__inner"
        @click="handlerShowViewer"
        :src="src"
        :style="[previewSrcList.length && { cursor: 'pointer' }]"
      />
      <e6-image-viewer
        v-show="showViewer"
        :on-close="closeViewer"
        :url-list="previewSrcList"
      ></e6-image-viewer>
    </template>
  </div>
</template>

<script>
import imageExist from "e6yun-ui/src/utils/image-exist";
import E6ImageViewer from "../E6ImageViewer/index";

export default {
  name: "E6Image",
  props: {
    src: {
      type: String
    },
    previewSrcList: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  components: {
    E6ImageViewer
  },

  data() {
    return {
      failType: "none",
      isExist: true,
      showViewer: false
    };
  },

  watch: {
    src: {
      handler(newVal) {
        if (!!this.newVal) {
          this.checkImage();
        }
      },
      immediate: true
    }
  },

  mounted() {
    this.checkImage();
  },

  methods: {
    checkImage() {
      if (!this.src) {
        this.isExist = false;
        this.failType = "none";
      } else {
        imageExist(this.src).then(val => {
          this.isExist = val;
          if (!val) {
            this.failType = "error";
          }
        });
      }
    },
    handlerShowViewer() {
      if (this.previewSrcList.length) {
        this.showViewer = true;
      }
    },
    closeViewer() {
      this.showViewer = false;
    }
  }
};
</script>

<style>
@import url("./index.css");
</style>
